
import { StyleValue } from '@/shared/app/model/StyleValue';
import Base from '@/shared/app/ui/Base.vue';
import SizeGettersBase from '@/shared/app/ui/SizeGettersBase.vue';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component
export default class OriginsScroller extends mixins(Base, SizeGettersBase) {
  doneTimeout = 0;

  sizeBackdoor = false;

  beforeDestroy() {
    clearTimeout(this.doneTimeout);
  }

  get originsWithNameAndImage() {
    type Origin = {
      imageUrl: string;
      name: string;
    };
    const icons = this.dataset('icons');
    if (!icons) return [];
    return this.origins
      .map((originKey) => {
        if (icons[originKey]) {
          const parts = icons[originKey].toString().split('|');
          if (parts.length === 2)
            return {
              imageUrl: parts[0],
              name: parts[1],
            } as Origin;
        }
        return undefined;
      })
      .filter((origin) => Boolean(origin)) as Origin[];
  }

  get origins() {
    return (this.config?.origins?.toString() || '').split(',');
  }

  @Watch('origins')
  originsWatcher() {
    this.$nextTick().then(() => {
      this.sizeBackdoor = !this.sizeBackdoor;
    });
  }

  get originStyle(): StyleValue {
    return {
      fontSize: `${this.sizeFactor * 3.6}rem`,
      marginLeft: `${this.sizeFactor * 2}rem`,
      marginRight: `${this.sizeFactor * 2.8}rem`,
    };
  }

  imageStyle(url: string): StyleValue {
    const size = `${this.sizeFactor * 5.6}rem`;
    return {
      backgroundImage: `url(${url})`,
      height: size,
      width: size,
      marginRight: `${this.sizeFactor * 2.2}rem`,
    };
  }

  get scroll() {
    return this.fakeSizeWidth > this.width;
  }

  get fakeSizeWidth() {
    // eslint-disable-next-line no-unused-expressions
    this.sizeGetterBackdoor;
    // eslint-disable-next-line no-unused-expressions
    this.sizeBackdoor;
    if (this.$refs.sizefake) {
      return (this.$refs.sizefake as HTMLElement).offsetWidth;
    }
    return 1;
  }

  get containerStyle(): StyleValue {
    if (!this.scroll) return { justifyContent: 'center', padding: `0 ${this.sizeFactor}rem` };
    return {};
  }

  get innerStyle(): StyleValue {
    if (this.scroll) {
      return {
        animationDuration: `${this.scrollDuration}s`,
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
      };
    }
    return {};
  }

  get scrollDuration() {
    return this.fakeSizeWidth / 140;
  }

  get scrollArray() {
    if (this.scroll) return [1, 2];
    return [1];
  }

  get inner() {
    if (this.$refs.inner) return this.$refs.inner as HTMLDivElement;
    return undefined;
  }

  /**
   * @description Calcule le délai avant émission du Done
   */
  get doneDuration() {
    // Si le scroll est actif alors on calcule quelque chose selon la durée d'un scroll complet
    if (this.scroll) return (this.scrollDuration / 1.5) * 1000;
    // Sinon, simplement, 670ms par origine
    return this.origins.length * 670;
  }

  /**
   * @description (re)lance le timeout de Done selon les conditions du composant
   */
  @Watch('doneDuration')
  initializeDoneTimeout() {
    clearTimeout(this.doneTimeout);
    this.doneTimeout = setTimeout(() => {
      this.emitDone();
      this.initializeDoneTimeout();
    }, this.doneDuration);
  }
}
